import maplibregl from "maplibre-gl";
import { mapConfig } from "./map-config";
import { buildMarkerElement, fetchAndPlotRouteOnMap } from "./utils/route";

const map = new maplibregl.Map({
  ...mapConfig,
  zoom: 2,
  interactive: false,
  keyboard: false,
  preserveDrawingBuffer: false,
});

map.on("style.load", async function () {
  const $mapElement = $('#map');
  const lat = +$mapElement.data('lat');
  const lon = +$mapElement.data('lng');
  const routestackId = $mapElement.data('routestack-id');

  await fetchAndPlotRouteOnMap(routestackId, map);

  new maplibregl
    .Marker({
      element: buildMarkerElement('/assets/images/mill-marker.png'),
      draggable: false,
    })
    .setLngLat(new maplibregl.LngLat(lon, lat))
    .addTo(map);

});
